import { Flex } from 'antd';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import styles from './nav-mobile.module.scss';
import { Button } from '@/components/button/button';
import LogoMark from '@/assets/icons/voicesphere-mark.svg?react';
import Hamburger from '@/assets/icons/hamburger-menu.svg?react';

interface NavMobileProps {
  className?: string;
  toggleMenu: () => void;
}

export default function NavMobile({ className, toggleMenu }: NavMobileProps) {
  return (
    <Flex className={clsx(styles.container, className)}>
      <Link to="/">
        <LogoMark data-testid="logo-icon" className={styles.logo} />
      </Link>
      <Button
        data-testid="nav-mobile-button"
        buttonVariant="tertiary"
        onClick={toggleMenu}
        icon={<Hamburger className={styles.icon} style={{ width: '30px', height: '30px' }} />}
      />
    </Flex>
  );
}
